"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
class UserClient {
    constructor(authService) {
        this.authService = authService;
    }
    ;
    async getCurrentUser() {
        const response = await this.authService.get('', '../user');
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=UserClient.js.map